import { render, staticRenderFns } from "./SchoolSearchSelect.vue?vue&type=template&id=a449db34&scoped=true"
import script from "./SchoolSearchSelect.vue?vue&type=script&lang=js"
export * from "./SchoolSearchSelect.vue?vue&type=script&lang=js"
import style0 from "./SchoolSearchSelect.vue?vue&type=style&index=0&id=a449db34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a449db34",
  null
  
)

export default component.exports